module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (222).8e68385b.jpg";